export const iconFontAwesomeArrowsArrowsSpin = (
	<i className="fa-solid fa-arrows-spin"></i>
);
